<template>
  <VTooltip :text="t('Create consultation')" :location="'top'" :offset="0">
    <template #activator="{ props }">
      <VBtn
        v-if="config.canCreateConsultations"
        data-testid="create-consultation-btn"
        v-bind="props"
        :active="false"
        class="!min-w-[28px] !min-h-[28px] !w-[28px] !h-[28px] !p-0 [&::after]:hidden"
        :class="config.isConsultationDisabled ? 'opacity-50' : 'opacity-100'"
        color="primary"
        variant="plain"
        :disabled="config.isConsultationDisabled"
        @click="$emit('create-consultation-click')"
      >
        <img
          src="/calendar-add.svg"
          alt="Create consultation"
          class="place-self-center w-[20px] h-[20px]"
        />
      </VBtn>
    </template>
  </VTooltip>

  <VTooltip :text="t('Emergency Call')" :location="'top'" :offset="0">
    <template #activator="{ props }">
      <VBtn
        v-if="config.canCreateConsultations"
        data-testid="emergency-btn"
        v-bind="props"
        :active="false"
        class="!min-w-[28px] !min-h-[28px] !w-[28px] !h-[28px] !p-0 [&::after]:hidden"
        :class="config.isEmergencyDisabled ? 'opacity-50' : 'opacity-100'"
        color="secondary"
        variant="plain"
        :disabled="config.isEmergencyDisabled"
        @click="$emit('emergency-click')"
      >
        <VIcon color="secondary" size="20" icon="emergency" class="material-icons-round" />
      </VBtn>
    </template>
  </VTooltip>

  <VMenu>
    <template #activator="{ props }">
      <VTooltip :text="t('More actions')" :location="'top'" :offset="0">
        <template #activator="{ props: tooltipProps }">
          <VBtn
            v-if="config.shouldAllowPatientActions"
            data-testid="menu-btn"
            v-bind="mergeProps(props, tooltipProps)"
            icon="more_vert"
            color="primary"
            variant="plain"
            size="small"
            class="!min-w-[28px] !min-h-[28px] !w-[28px] !h-[28px] !p-0 [&::after]:hidden"
          />
        </template>
      </VTooltip>
    </template>

    <VList rounded="2">
      <VListItem
        v-if="config.isManuallyCreatedPatient"
        data-testid="edit-patient-item"
        @click="$emit('edit-patient-click')"
      >
        <VListItemTitle>{{ t('Edit patient') }}</VListItemTitle>
      </VListItem>

      <VListItem data-testid="close-case-item" @click="$emit('close-case-click')">
        <VListItemTitle>{{ t('Close case') }}</VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { mergeProps } from 'vue'

const { t } = useI18n()

interface ActionConfig {
  canCreateConsultations: boolean
  isConsultationDisabled: boolean
  isEmergencyDisabled: boolean
  shouldAllowPatientActions: boolean
  isManuallyCreatedPatient: boolean
}

defineProps<{
  config: ActionConfig
}>()

defineEmits<{
  (e: 'create-consultation-click'): void
  (e: 'emergency-click'): void
  (e: 'edit-patient-click'): void
  (e: 'close-case-click'): void
}>()
</script>

<style lang="scss" scoped></style>
